import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGodAuth } from '../../context/GodAuthContext';

const GOLD = '#B7791F';
const GOLD_LIGHT = '#FEF3C7';
const GOLD_BORDER = '#F6AD55';

export default function GodLogin() {
  const { login }               = useGodAuth();
  const navigate                = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      setError('Username and password are required');
      return;
    }
    setError(''); setLoading(true);
    try {
      await login(username.trim(), password);
      navigate('/god/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={S.page}>
      <div style={S.card}>
        {/* God Mode badge */}
        <div style={S.badge}>⚡ GOD MODE</div>

        <div style={S.logoArea}>
          <div style={S.logoMark}>K</div>
          <h1 style={S.appName}>Tracern</h1>
          <p style={S.tagline}>Platform Control Centre</p>
          <p style={{ fontSize: '11px', color: '#9CA3AF', marginTop: '2px' }}>
            by Mahashunya Innovation Labs
          </p>
        </div>

        {error && (
          <div style={S.errorBox}>{error}</div>
        )}

        <form onSubmit={handleSubmit} style={S.form}>
          <div>
            <label style={S.label}>Username</label>
            <input
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="God Mode username"
              autoCapitalize="none"
              autoComplete="username"
              style={S.input}
            />
          </div>
          <div>
            <label style={S.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="God Mode password"
              autoComplete="current-password"
              style={S.input}
            />
          </div>
          <button type="submit" disabled={loading} style={S.btn}>
            {loading ? 'Authenticating…' : 'Enter God Mode'}
          </button>
        </form>

        <p style={S.disclaimer}>
          Restricted access. All actions are permanently logged.
        </p>
        <p style={{ textAlign: 'center', fontSize: '11px', color: '#9CA3AF', marginTop: '4px' }}>
          © {new Date().getFullYear()} Mahashunya Innovation Labs
        </p>
      </div>
    </div>
  );
}

const S = {
  page: {
    minHeight: '100vh',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '24px 16px',
    background: 'linear-gradient(135deg, #FFFBEB 0%, #FEF3C7 50%, #FDE68A 100%)',
  },
  card: {
    background: '#fff',
    borderRadius: '20px', padding: '40px 32px',
    width: '100%', maxWidth: '400px',
    boxShadow: '0 20px 40px rgba(180,130,0,0.15)',
    position: 'relative',
    border: `1px solid ${GOLD_BORDER}`,
  },
  badge: {
    position: 'absolute', top: '-14px', left: '50%', transform: 'translateX(-50%)',
    background: `linear-gradient(135deg, ${GOLD} 0%, #D97706 100%)`,
    color: '#fff',
    fontSize: '11px', fontWeight: 800, letterSpacing: '0.1em',
    padding: '4px 16px', borderRadius: '999px',
    boxShadow: `0 2px 8px ${GOLD}66`,
  },
  logoArea:  { textAlign: 'center', marginBottom: '24px', marginTop: '8px' },
  logoMark: {
    width: '52px', height: '52px', borderRadius: '14px',
    background: `linear-gradient(135deg, ${GOLD} 0%, #D97706 100%)`,
    color: '#fff',
    fontSize: '26px', fontWeight: 700,
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    marginBottom: '10px',
    boxShadow: `0 4px 14px ${GOLD}44`,
  },
  appName:   { fontSize: '26px', fontWeight: 700, color: '#1F2937', marginBottom: '4px' },
  tagline:   { fontSize: '13px', color: '#6B7280' },
  errorBox:  {
    padding: '10px 14px', background: '#FFF5F5', border: '1px solid #FEB2B2',
    borderRadius: '8px', color: '#C53030', fontSize: '13px', marginBottom: '16px',
    textAlign: 'center',
  },
  form:  { display: 'flex', flexDirection: 'column', gap: '16px' },
  label: { display: 'block', fontSize: '13px', fontWeight: 500, color: '#374151', marginBottom: '6px' },
  input: {
    width: '100%', padding: '10px 14px', borderRadius: '8px', fontSize: '14px',
    border: '1.5px solid #E5E7EB', color: '#1F2937', background: '#fff',
    outline: 'none', transition: 'border-color 0.15s',
  },
  btn: {
    width: '100%', padding: '12px', borderRadius: '10px',
    background: `linear-gradient(135deg, ${GOLD} 0%, #D97706 100%)`,
    color: '#fff', border: 'none', cursor: 'pointer',
    fontSize: '15px', fontWeight: 600, marginTop: '4px',
    boxShadow: `0 4px 12px ${GOLD}44`,
  },
  disclaimer:{ textAlign: 'center', fontSize: '12px', color: '#9CA3AF', marginTop: '20px' },
};
